function shouldLog() {
  return console.log && process.env.NODE_ENV === 'development';
}

export function info(...args) {
  if (!shouldLog()) return
  console.log(...args)
}

export function warn(...args) {
  if (!shouldLog()) return
  console.warn(...args)
}

export function error(...args) {
  if (!shouldLog()) return
  console.error(...args)
}

export default {
  info,
  warn,
  error
}


// WEBPACK FOOTER //
// ./src/util/log.js